import { render, staticRenderFns } from "./ItemModalShop.vue?vue&type=template&id=bbf56aba&"
import script from "./ItemModalShop.vue?vue&type=script&lang=js&"
export * from "./ItemModalShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports